import { TFunction } from 'i18next';
import * as yup from 'yup';

export const fields = [
  'claimsHandler',
  'claimsStatus',
  'referenceNo',
  'reportedDate',
  'dateOfLoss',
  'causeOfLoss',
  'city',
  'country',
] as const;

export type BinderClaimFormFields = (typeof fields)[number];

export const getValidationSchema = (t: TFunction) =>
  yup.object().shape({
    claimsHandler: yup.string().required(
      t('validation.required', {
        field: t('claim.binderClaimsActions.lossDetails.claimsHandler'),
      })
    ),

    claimsStatus: yup.string().required(
      t('validation.required', {
        field: t('claim.binderClaimsActions.lossDetails.claimsStatus'),
      })
    ),

    referenceNo: yup.string().required(
      t('validation.required', {
        field: t('claim.binderClaimsActions.lossDetails.referenceNo'),
      })
    ),

    reportedDate: yup.mixed().required(
      t('validation.required', {
        field: t('claim.binderClaimsActions.lossDetails.reportedDate'),
      })
    ),

    dateOfLoss: yup.mixed().required(
      t('validation.required', {
        field: t('claim.binderClaimsActions.lossDetails.dateOfLoss'),
      })
    ),

    causeOfLoss: yup.string().required(
      t('validation.required', {
        field: t('claim.binderClaimsActions.lossDetails.causeOfLoss'),
      })
    ),

    city: yup.string().required(
      t('validation.required', {
        field: t('general.city'),
      })
    ),

    country: yup.string().required(
      t('validation.required', {
        field: t('general.country'),
      })
    ),
  });
